import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { EditSessionService } from '../_service/edit-session.service';

@Injectable({ providedIn: 'root' })
export class EditSessionSoftLockGuard implements CanActivate {
  constructor(
    private readonly editSessionService: EditSessionService,
    private readonly confirmationService: ConfirmationService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const noteId = (route.paramMap.get('_id') || '').trim();
    if (!noteId) {
      return true;
    }

    const conflict = await this.editSessionService.checkForConflictingSession(noteId);
    if (!conflict) {
      return true;
    }

    return new Promise<boolean>((resolve) => {
      this.confirmationService.confirm({
        header: 'Note already open',
        message:
          'This note is already open for editing in another browser tab. Opening it here as well may lead to conflicting changes. Do you want to continue anyway?',
        icon: 'pi pi-exclamation-triangle',
        rejectLabel: 'Cancel',
        acceptLabel: 'Open anyway',
        defaultFocus: 'reject',
        dismissableMask: true,
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }
}
